var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7368 26H30.2632C27.3684 26 25 28.3684 25 31.2632V68.1053C25 71 27.3684 73.3684 30.2632 73.3684H69.7368C72.6316 73.3684 75 71 75 68.1053V31.2632C75 28.3684 72.6316 26 69.7368 26ZM69.7368 31.2632V39.1579H30.2632V31.2632H69.7368ZM56.5789 68.1053H43.4211V44.4211H56.5789V68.1053ZM30.2632 44.4211H38.1579V68.1053H30.2632V44.4211ZM61.8421 68.1053V44.4211H69.7368V68.1053H61.8421Z",
    fill: "#2E2E2E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.37c0d6c531908b05e4ba01d5aa743a82.svg";
export { ForwardRef as ReactComponent };